<template>
  <div>
    <div class="row" :id="$route.name">
      <div class="col-12 mb-3">
        <user-info-header></user-info-header>
      </div>
      <div class="col-md-3 col-12">
        <small id="LblCommodity">کالا</small>
        <input type="text" class="form-control required" v-model="item.commodity" />
        <small id="LblCount">تعداد</small>
        <input type="number" class="form-control text-center required" dir="ltr" id="inputCount" v-model="item.count" />
      </div>
      <div class="col-md-9 col-12">
        <small id="LblFor">توضیحات</small>

        <textarea class="form-control" style="resize: none; height: 80px" v-model="item.for"></textarea>
      </div>
      <div class="col-md-10 col-12"></div>
      <div class="col-md-2 col-12">
        <button v-if="EditMode" class="btn btn-warning w-100" @click="submitEdit">ویرایش</button>
        <button v-else class="btn btn-success w-100" @click="submit">ثـبـت</button>
      </div>
    </div>
  </div>
</template>
<script>
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
import UserInfoHeader from '@/components/AutomAtion/UserInfoHeader.vue'
export default {
  components: { SearchableCombo, UserInfoHeader },
  props: ['EditMode', 'EditRow','DataFormProps'],

  data() {
    return {
      item: {},
    }
  },

  mounted() {
    this.item = {}
    this.item.for = ''
    if (this.EditMode) {
      if (this.DataFormProps) {
        this.item.id=this.EditRow.id
        this.item.commodity=this.EditRow.commodity
        this.item.count=this.EditRow.count
        this.item.for=this.EditRow.for
        this.item.TblUserId=this.$session.get('UserInfo').tblUserId
        this.item.dateTimeInsert= this.EditRow.dateTimeInsert
        this.item.tblUserGrpIdInsert= this.EditRow.tblUserGrpIdInsert
      }
      else{
        this.item = this.EditRow
      }
    }
  },

  methods: {
    submit() {
      if (!this.$ValidForm(this.$route.name)) {
        return
      }

      let formData = new FormData()
      formData.append('Commodity', this.item.commodity)
      formData.append('Count', this.item.count)
      formData.append('For', this.item.for)

      this.$PostData_new('post', 'BuyRequest', formData, true)
        .then((res) => {
          console.log("😎 ~ .then ~ res:", res)
          if (res.isSuccess) {
            this.$mySweetDefaultTost('عملیات موفق', res.message, 'success', 2000)
            this.$emit('Result', res.isSuccess)
          } else {
            this.$mySweetDefaultTost('عملیات ناموفق', res.message, 'error', 2000)
          }
        })
        .catch((err) => {
          this.$mySweetDefaultTost('عملیات ناموفق', 'خطای سمت سرور', 'error', 2000)
          console.error(err)
        })
    },
    submitEdit() {
      if (!this.$ValidForm(this.$route.name)) {
        return
      }
      this.$PostData_new('put', 'BuyRequest', this.item)
        .then((res) => {
          if (res.isSuccess) {
            this.$SetLog(this.item, 0, 0)
            this.$mySweetDefaultTost('عملیات موفق', res.message, 'success', 2000)
            this.$emit('Result', res.isSuccess)
            console.log("😎 ~ .then ~ res:", res.isSuccess)
          } else {
            this.$mySweetDefaultTost('عملیات ناموفق', res.message, 'error', 2000)
          }
        })
        .catch((err) => {
          this.$mySweetDefaultTost('عملیات ناموفق', 'خطا سمت سرور', 'error', 2000)
          console.error(err)
        })
    },
  },
}
</script>
